import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { Sidebar } from '../components/Sidebar';
import { Navbar } from '../components/Navbar';

export const AuthenticatedLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const handleChatClick = (e) => {
    const isMobile = window.innerWidth < 1024; // lg breakpoint
    
    if (isMobile) {
      e.preventDefault();
      // Navigate to chat with state to show message list
      navigate('/chat-interface', { 
        state: { resetToMessageList: true }
      });
    }
    // On desktop, let the link work normally
  };

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(!sidebarOpen)} />
      <div className="flex-1 flex flex-col overflow-hidden relative">
        <Navbar onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
        <main className="flex-1 overflow-auto">
          <div className="max-w-7xl mx-auto p-3 sm:p-4 md:p-6">
            {children}
          </div>
        </main>

        {/* Floating Chat Button */}
        <Link
          to="/chat-interface"
          onClick={handleChatClick}
          className="fixed right-4 sm:right-6 md:right-8 bottom-24 sm:bottom-8 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-3 sm:p-4 shadow-lg hover:shadow-xl transition-all duration-300 z-40 flex items-center justify-center"
          title="Chat with AI Assistant"
        >
          <MessageCircle className="w-5 h-5 sm:w-6 sm:h-6" />
        </Link>
      </div>
    </div>
  );
};
